import { PersonaSize } from '@fluentui/react/lib/Persona';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export const getPersonaSize = (
    isSingleLine: boolean,
    densityModeString: string
): PersonaSize.size16 | PersonaSize.size24 | PersonaSize.size28 | PersonaSize.size32 => {
    switch (densityModeString) {
        case 'compact':
            return PersonaSize.size16;
        case 'medium':
            return PersonaSize.size24;
        default:
            return isSingleLine ? PersonaSize.size28 : PersonaSize.size32;
    }
};

export const getPersonaSizeForMLRow = (
    isSingleLine: boolean,
    densityModeString: string
): PersonaSize.size16 | PersonaSize.size24 | PersonaSize.size28 | PersonaSize.size32 => {
    // In denseless mode, 3-col (MCV) views use 32px avatars for all densities
    if (isGlobalFeatureEnabled('rp-denseless') && !isSingleLine) {
        return PersonaSize.size32;
    }
    switch (densityModeString) {
        case 'compact':
            return isSingleLine ? PersonaSize.size16 : PersonaSize.size24;
        case 'medium':
            return isSingleLine ? PersonaSize.size24 : PersonaSize.size28;
        default:
            return isSingleLine ? PersonaSize.size28 : PersonaSize.size32;
    }
};
